import { render, staticRenderFns } from "./CustomerCardBasicData.vue?vue&type=template&id=a7a1bb3a&scoped=true"
import script from "./CustomerCardBasicData.vue?vue&type=script&lang=ts"
export * from "./CustomerCardBasicData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a1bb3a",
  null
  
)

export default component.exports